export default {
  notifications: { english: "Notifications", spanish: "Notificaciones" },
  logout: { english: "Logout", spanish: "Cerrar sesión" },
  welcome: { english: "Welcome", spanish: "Bienvenidos" },
  myProfile: { english: "My Profile", spanish: "Mi perfil" },
  home: { english: 'Home', spanish: 'Home'},
  resources : { english: 'Resources', spanish: 'Recursos'},
  appointments: { english: 'Appointments', spanish: 'Citas'},
  myAppointments: { english: 'My Appointments', spanish: 'Mis Citas'},
  documents: { english: 'Documents', spanish: 'Documentos'},
  orders: { english: 'Orders', spanish: 'Pedidos'},
  liveChat: { english: 'Live Chat', spanish: 'Chat Online'},
  signature: { english: "Signature", spanish: "Firma" },
  ofPosition: { english: "of", spanish: "de" },
};
